/*
 * @Date: 2020-08-28 14:20:36
 * @Author: MX
 * @LastEditTime: 2020-09-10 19:56:39
 * @Description: 
 */
import { post, get } from '@/http/request'
import { APICUS } from "@/constants"
import apiTestMockPost from '@/http/apiTestMock'

//获取图形验证码
export const getCaptcha = () => get(`/${APICUS}/captcha`)
//发送注册短信验证码
export const sendSms = (params) => post(`/${APICUS}/user/sendSms`,params)
//通用短信验证码
export const sendMessage = (params) => post(`/${APICUS}/sms/sendSms`,params)
//注册
export const register = (params) => post(`/${APICUS}/user/register`,params)
//登录
export const login = (params) => post(`/${APICUS}/user/login`,params)
// 退出
export const logOut = (params) => post(`/${APICUS}/user/loginOut`, params)
//校验手机与账号
export const checkUserByPhoneOrAccount = (params) => post(`/${APICUS}/user/checkUserByPhoneOrAccount`,params)
//重置密码
export const resetPwd = (params) => post(`/${APICUS}/user/resetPwd`,params)
//获取省市区
export const areaList = (params) => post(`/${APICUS}/area/list`,params)
//提交开发者认证
export const devCerCommit = (params) => post(`/${APICUS}/cer/devCerCommit`,params)
//修改开发者认证
export const updateCerCommit = (params) => post(`/${APICUS}/cer/updateInterfaceContactor`,params)
//获取图片完整链接
export const getImgUrl = (params) => get(`/${APICUS}/file/getImgUrl`,params)
//提交企业认证
export const companyCerCommit = (params) => post(`/${APICUS}/cer/companyCerCommit`,params)
//修改企业认证
export const updateCompanyCer = (params) => post(`/${APICUS}/cer/updateCompanyCer`,params)
//接口管理列表
export const getInterfaceList = (params) => get(`/${APICUS}/yl-op-user-interface/list`,params)
//接口申请
export const apply = (params) => post(`/${APICUS}/yl-op-user-interface/apply`,params)
//修改手机号
export const changePhone = (params) => post(`/${APICUS}/user/changePhone`,params)
//查询认证信息
export const getCertificationInfo = (params) => get(`/${APICUS}/cer/certificationInfo`,params)
//停用
export const stopUse = (params) => post(`/${APICUS}/yl-op-user-interface/cancle`,params)
//签名工具/账号秘钥签名
export const accountSign = (params) => post(`/${APICUS}/help-center/accountSign`,params)
//签名工具/json秘钥签名
export const headersSign = (params) => post(`/${APICUS}/help-center/headersSign`,params) 
//上传图片
export const UPLOADUMG = `${process.env.VUE_APP_API_URL}/${APICUS}/file/uploadImg`
//一联模板下载，下载地址更换
export const downloadOneTemplate = `https://ocms.jtjms-ae.com/baw/openapi/J%26T%20one-joint%20waybill%20template.xlsx`
//二联模板下载
export const downloadTwoTemplate = `${process.env.VUE_APP_API_URL}/${APICUS}/file/downloadTwoTemplate`
//测试api 
export const apiTestApiMock = (params,url) => apiTestMockPost.post(`/${APICUS}${url}`,params) 
//公告 - 分页获取
export const noticePage = (params) => post(`/${APICUS}/notice/webPage`,params)
//公告 - 新闻详情
export const noticeDetail = (params) => get(`/${APICUS}/notice/webDetail`,params)
//控制-调试
export const changeStatus = (params) => post(`/${APICUS}/yl-op-user-interface/changeStatus`,params)
//控制-撤销
export const revoke = (params) => post(`/${APICUS}/yl-op-user-interface/revoke`,params)

export const updatePwd = (params) => post(`/${APICUS}/user/updatePwd`, params)
